import { NavigationStepPathEnum } from '@/constants/navigation';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useRouter } from 'next/navigation';
import { useShallow } from 'zustand/react/shallow';

export const useRedirectToFirstStepIfBookingCompleted = () => {
  const router = useRouter();
  const { transactionId } = usePrenuvoStore(
    useShallow((state) => ({
      transactionId: state.payment.transactionId,
    })),
  );

  if (!transactionId) return;

  router.push(NavigationStepPathEnum.SCAN_DETAILS);
};
